import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotationReviewRemoved = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .18
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.75732,
			y: 6.34314,
			width: 14,
			height: 2,
			rx: 1,
			transform: "rotate(45 7.75732 6.34314)",
			fill: "#DD0000"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 2,
			rx: 1,
			transform: "matrix(-0.707107 0.707107 0.707107 0.707107 16.2427 6.34314)",
			fill: "#DD0000"
		})
	]
});
const ForwardRef = forwardRef(SvgAnnotationReviewRemoved);
export { ForwardRef as ReactComponent };
